import type { AllowedSource } from './types';

interface Props {
  restrictSources: boolean;
  allowedSources: AllowedSource[];
}

export function AllowedSourcesReadOnly({
  restrictSources,
  allowedSources,
}: Props) {
  if (!restrictSources || allowedSources.length === 0) {
    return null;
  }

  return (
    <table className="table" data-cy="allowed-sources-readonly-table">
      <thead>
        <tr>
          <th>Registry URL prefix</th>
          <th>Scope</th>
          <th>Namespaces</th>
        </tr>
      </thead>
      <tbody>
        {allowedSources.map((source) => (
          <tr key={source.registryUrlPrefix}>
            <td>{source.registryUrlPrefix}</td>
            <td>
              {source.scope === 'global' ? 'Global' : 'Specific namespaces'}
            </td>
            <td>
              {source.scope === 'namespaces'
                ? source.namespaces.join(', ')
                : 'All namespaces'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
